import { createStore } from "vuex";
import { getStorage, setStorage } from "../services/storage";
import { http } from "@/services/http";
import i18n from "@/i18n";
const state = {
  auth: getStorage('auth') || null,
  loading:false,
  settings:null,
};
const SUPPORTED_LOCALES = ['en', 'he'];

export default new createStore({
  state,
  mutations: {
    SET_AUTH(state, auth) {
      state.auth = auth;
    },
    SET_LOADER:(state,flag)=>{
      state.loading = flag;
    },
    SET_LOCALE(state, locale) {
      state.locale = locale
      setStorage('locale', locale)
    },
    SET_INSURANCE_SETTINGS(state, data) {
      state.settings = data
    }
  },
  actions: {
    setAuth: async ({ commit }, data) =>{
      commit('SET_AUTH', data);
    },
    setLoader: async ({commit}, flag) => {
      commit('SET_LOADER', flag);
    },
    setLocale: async({ commit }, locale) =>{
      if (!SUPPORTED_LOCALES.includes(locale)) {
        locale = 'en'
      }
      i18n.global.locale.value = locale;

      commit('SET_LOCALE', locale)
    },
    async ensureInsuranceSettings({ state, dispatch }) {
      if (state.settings && Object.keys(state.settings).length) {
        return
      }
      await dispatch('loadInsuranceSettings')
    },
  
    async loadInsuranceSettings({ commit }) {
      const response = await http.get('global-settings/misgav');
      const data = response?.data ?? {};
      commit('SET_INSURANCE_SETTINGS', data);
    }
  },
  getters: {
    getAuth(state) {
      return state.auth;
    },
    loader(state) {
      return state.loading;
    },
    locale: state => {
      return state.locale
    },
    settings: state => {
      return state.settings
    }
  },
});
